import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import setGlobalState from '../../../../../redux/setGlobalState';
import {getAccounts, getAccountsCount} from '../../../../../redux/suggestions/suggestionsActions';
import useAccountsScroll from './useAccountsScroll';

export default function useAccountSwitcher(isOpen: boolean) {
    const accounts = useSelector((s: any) => s.suggestions.accounts) || [];
    const hasMultiple = useSelector((s: any) => s.suggestions.hasMultipleAccounts);
    const countXHR = useSelector((s: any) => s.suggestions.getAccountsCountXHR);
    const [search, setSearch] = useState('');
    const {popupRef, resetPagination} = useAccountsScroll(isOpen, search);

    useEffect(() => {
        if(!countXHR) getAccountsCount();
    }, [countXHR]);

    const fetchAccounts = (value = '') => {
        setSearch(value);
        resetPagination();
        setGlobalState('suggestions.accounts', []);
        getAccounts({search: value, limit: 20, offset: 0});
    };

    return {accounts, search, fetchAccounts, popupRef, hasMultiple};
}
